import { api } from '@/api';

const getInvestors = (params) => {
  return api.get('/api/kyc/v1/superAdmin/investors', { params: params });
};
const deleteInvestor = ({ investorId }) => {
  return api.delete('/api/kyc/v1/superAdmin/investor', {
    data: {
      investorId: investorId
    }
  });
};
const uploadDeepCheckReport = ({ checkId, file }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('checkInvestorId', checkId);

  return api.post('/api/kyc/v1/superAdmin/checkInvestor/uploadReport', formData);
};

export const superAdminApi = {
  getInvestors,
  deleteInvestor,
  uploadDeepCheckReport
};
